import reactUpdate from 'immutability-helper';
import _ from 'underscore';
import {assert} from 'Asserts';

import * as NoteStoreTransforms from 'notebook/notes/NoteStoreTransforms';
import pick from 'util/pick';

import EntryVersionUtil from './EntryVersionUtil';

const EntryUtil = {
  entryVersionUpdate(op) {
    // Helper for abstracting away the path to the entryVersion on an entry object.
    // TODO(T1044): For now, because an entry's object does not nest an entry version, the entry is
    //              effectively an entry version, so this just returns the op
    return op;
  },

  pickRevertableFields(entry) {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(pick(entry, 'name'), EntryVersionUtil.pickRevertableFields(entry));
  },

  sanitizeEntry(entry, oldEntry = null) {
    return EntryVersionUtil.sanitizeEntryVersion(entry, oldEntry, entry.id);
  },

  prepareForStore(entry, cidIdMap) {
    const entryFields = [
      'id',
      'versionId',
      'folder',
      'editURL',
      'name',
      'permissions',
      'review',
      'tags',
      'tagSchema',
      'created_at',
      'modified_at',
      'thirdPartyStorageServiceData',
      'humanId',
      'templateVersionId',
      'templateUrl',
      'templateVersionTimestamp',
      'authors',
      'archiveRecord',
      'lock',
    ];

    // TODO(T1044): EntryVersion is merged with Entry in the server payload, so we omit entry-specific fields
    // in preparing the EntryVersion (and add in the entry version id), and then recombine with the
    // entry-specific fields for the store.
    const entryVersion = EntryVersionUtil.prepareForStore(
      _.chain(entry)
        .omit(...entryFields)
        .extend({id: entry.versionId})
        .value(),
      cidIdMap,
      entry.id
    );
    return {...entryVersion, ...pick(entry, ...entryFields), isStale: false};
  },

  prepareForSave(entry, cidIdMap, savingNoteParts) {
    const entryVersion = EntryVersionUtil.prepareForSave(entry, cidIdMap, entry.id, savingNoteParts);
    return {...entryVersion, ...pick(entry, 'name')};
  },

  addTasksToEntry(entry) {
    return reactUpdate(entry, {note: {$set: NoteStoreTransforms.addTasksToNote(entry.note)}});
  },

  removeTasksFromEntry(entry) {
    if (entry.note == null) {
      return entry;
    }
    return reactUpdate(entry, {note: {$set: NoteStoreTransforms.removeTasksFromNote(entry.note)}});
  },

  // Returns the day of the current note part.
  getDayOfNotePart(index, days) {
    const daysUpToCurrent = days.filter((d) => d.index <= index);
    assert(daysUpToCurrent.length > 0, 'At least one day is expected before the current index.');
    return _.max(daysUpToCurrent, (d) => d.index);
  },
};

export default EntryUtil;
